<template>
  <v-card>
    <v-toolbar dark color="darken-2" elevation="0" @short="true">
      <v-btn icon dark @click="fechar()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>
        <span v-if="viewEditorial">Novo Editorial</span>
        <span v-else>Editar Editorial</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="salvarEditorial()">Salvar</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="4">
            <mb-select-autor v-model="editorial.autor_id" />
          </v-col>
          <v-col cols="3">
            <mb-data
              prependInnerIcon="event"
              :data="editorial.data"
              @dataSelecionada="editorial.data = $event"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="5" class="mr-12">
            <mb-text-field
              v-model="editorial.titulo"
              required
              label="Titulo"
            />
          </v-col>
          <v-col cols="6">
            <mb-text-field
              v-model="editorial.descricao"
              required
              label="Descrição"
            />
          </v-col>
        </v-row>
        <v-row no-gutters>

        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import EditorialInput from "@/classes/editorialInput.js";
export default {
  components: {
  },
  props: ["viewEditorial", "setEditorial"],
  data() {
    return {
      editorial: new EditorialInput()
    };
  },
  mounted() {
    this.carregaEditorial();
  },
  methods: {
    carregaEditorial() {
      this.editorial = this.setEditorial;
      this.editorial.autor_id = this.setEditorial.autor.id;
    },
    salvarEditorial() {
      if (this.$utils.isNotNull(this.editorial.titulo)) {
        if (this.$utils.isNotNull(this.editorial.data)) {
          if (this.$utils.isNotNull(this.editorial.autor_id)) {

            this.$emit("salvar", this.editorial);

          } else {
            this.$toast.warning("Selecione um autor.");
          }
        } else {
          this.$toast.warning("Selecione uma data.");
        }
      } else {
        this.$toast.warning("Digite um titulo.");
      }
    },
    fechar() {
      this.$emit("fechar", false);
    }
  },
  watch: {
  }
};
</script>

<style lang="scss" scoped>
</style>
